window.getCart = (callback) => {
  $.getJSON('/cart.js', callback)
}

// 配送日時計算に使われていた asyncGetCart() も不要なため削除しています

function removeDuplicatedProperty() {
  window.getCart(function (cart) {
    for (let index = 1; index <= cart.items.length; index++) {
      const properties = cart.items[index - 1].properties

      delete properties['名入れの確認1']
      delete properties['3']
      delete properties['4']
      delete properties['_pplr_preview']

      $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          line: index,
          properties,
        },
      });
    }
  });
}

// --- ここにあった makeAPiCall と displayDeliveryDate は削除しました ---
// --- $('button#checkout').attr('disabled', 'disabled') も削除しました ---

$(window).on('load', function () {
  // displayDeliveryDate() の呼び出しを削除し、プロパティの整理のみ実行します
  removeDuplicatedProperty()

  // 念のため、HTML側でボタンが無効化されていたり、ローディングテキストが出ている場合を考慮して
  // 強制的に通常の状態（クリック可能）に戻す処理を入れておきます
  $('button#checkout').removeAttr('disabled')
  $('span#js-checkout-loading-text').hide()
  $('span#js-checkout-text').show()
})

$('.js-gift-container-checkbox').on('change', function () {
  let prop = 'なし'
  const index = $(this).data('line-index')

  if ($(this).is(':checked')) {
    prop = 'あり'
  }

  window.getCart(function (cart) {
    const properties = cart.items[index - 1].properties

    properties['ラッピング'] = prop

    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        line: index,
        properties,
      },
    });
  });
})